module.exports = require("core-js/library/fn/date/now");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.9.2@@babel/runtime-corejs2/core-js/date/now.js
// module id = 2479
// module chunks = 0